export default __webpack_public_path__ + "assets/images/ba89884393dd2bd1161df4b3b638e9d1.svg";